const map = {
  Invisible: { bg: "bg-muted", text: "text-foreground/80" },
  Weak: { bg: "bg-intl/15", text: "text-intl" },
  Growing: { bg: "bg-yellow-100", text: "text-yellow-900" },
  Strong: { bg: "bg-emerald-100", text: "text-emerald-800" },
  "AI Recommended": { bg: "bg-cobalt", text: "text-white" },
  queued: { bg: "bg-muted", text: "text-foreground/70" },
  crawling: { bg: "bg-muted", text: "text-foreground/70" },
  scoring: { bg: "bg-muted", text: "text-foreground/70" },
  explaining: { bg: "bg-muted", text: "text-foreground/70" },
  recommending: { bg: "bg-muted", text: "text-foreground/70" },
  complete: { bg: "bg-emerald-100", text: "text-emerald-800" },
  failed: { bg: "bg-red-100", text: "text-red-700" },
};

export default function StatusBadge({ label, large }) {
  if (!label) return null;
  const m = map[label] || { bg: "bg-muted", text: "text-foreground/80" };
  return (
    <span
      data-testid="status-badge"
      className={`inline-flex items-center gap-2 ${m.bg} ${m.text} ${large ? "px-4 py-1.5 text-sm" : "px-2.5 py-1 text-xs"} font-mono uppercase tracking-widest`}
    >
      <span className="w-1.5 h-1.5 bg-current opacity-70" />
      {label}
    </span>
  );
}
